import BaseService from "src/packages/BaseService";

export default class UpdateService extends BaseService {
	static get className() {
		return "update";
	}
};
